export const AUTH_USER_SUCCESS = 'vivienda/user/AUTH_USER_SUCCESS'

export function fetchAuthUserSuccess(data) {
    return {
        type: AUTH_USER_SUCCESS,
        payload: data
    }
}